import React, { createContext, ReactNode, useContext, useMemo } from "react";

export type IsPreviewOrDemoValue = {
  isDemo: boolean;
  isPreview: boolean;
};

const defaultValue: IsPreviewOrDemoValue = {
  isDemo: false,
  isPreview: false,
};

export const IsPreviewOrDemoContext =
  createContext<IsPreviewOrDemoValue>(defaultValue);

export type IsPreviewOrDemoProviderProps = {
  children: ReactNode;
  isDemo: boolean;
  isPreview: boolean;
};

export const IsPreviewOrDemoProvider = ({
  children,
  isDemo,
  isPreview,
}: IsPreviewOrDemoProviderProps) => {
  const value = useMemo(
    () => ({
      isDemo,
      isPreview,
    }),
    [isDemo, isPreview],
  );

  return (
    <IsPreviewOrDemoContext.Provider value={value}>
      {children}
    </IsPreviewOrDemoContext.Provider>
  );
};

export const useIsPreviewOrDemo = (): IsPreviewOrDemoValue =>
  useContext(IsPreviewOrDemoContext);
